import { Checkbox, Chip, ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material"
import noop from "lib/noop"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { BlockKeyboard } from "lib/@components/block-clicks"
import { If } from "lib/@components/switch"

export function ClientDataMigrationItem({ item, onSelect = noop }) {
    const { selectedKeys, getKey } = useBoundContext()
    const buttonSx = item.migrated ? { pr: 12 } : undefined

    return (
        <BlockKeyboard>
            {/* The chip lives outside the button — a disabled ListItemButton dims its children
                and blocks pointer events, which would grey the chip and kill the tooltip */}
            <ListItem
                disablePadding
                data-cy="migration-item"
                secondaryAction={
                    <If value={item.migrated}>
                        <Tooltip title={migratedTooltip()}>
                            <Chip label="Migrated" size="small" color="primary" data-cy="migrated-chip" />
                        </Tooltip>
                    </If>
                }
            >
                {/* pr clears the Migrated chip so long titles cannot run underneath it */}
                <ListItemButton
                    onClick={handleClick}
                    dense
                    disabled={item.migrated}
                    sx={buttonSx}
                    data-cy="migration-item-select"
                >
                    <ListItemIcon>
                        <Checkbox
                            inputProps={{ "data-cy": "migration-item-checkbox" }}
                            edge="start"
                            checked={selectedKeys.has(getKey(item))}
                            disabled={item.migrated}
                            tabIndex={-1}
                            disableRipple
                        />
                    </ListItemIcon>
                    <ListItemText primary={item.label} />
                </ListItemButton>
            </ListItem>
        </BlockKeyboard>
    )

    function handleClick() {
        onSelect(item)
    }

    function migratedTooltip() {
        const when = item.migratedDate ? ` on ${new Date(item.migratedDate).toLocaleDateString()}` : ""
        return `Already migrated${when}. This item cannot be selected again.`
    }
}
